<template>
  <div class="deviceChart section" v-loading="isLoading" element-loading-spinner="el-icon-loading">
    <div class="section-header">
      <div class="tool">
        <el-date-picker
          v-show="currentCategoryVal.datepickerType == 'date'"
          v-model="chartDate"
          type="date"
          class="datepicker"
          :editable="false"
          :clearable="false"
        ></el-date-picker>
        <el-date-picker
          v-show="currentCategoryVal.datepickerType == 'month'"
          v-model="chartDate"
          type="month"
          class="datepicker"
          :editable="false"
          :clearable="false"
        ></el-date-picker>
        <el-date-picker
          v-show="currentCategoryVal.datepickerType == 'year'"
          v-model="chartDate"
          type="year"
          class="datepicker"
          :editable="false"
          :clearable="false"
        ></el-date-picker>
        <span
          v-for="(val,key) in categories"
          class="category"
          :class="{selected: currentCategoryKey==key}"
          :key="key"
          @click="currentCategoryKey=key"
        >{{val.label}}</span>
      </div>
    </div>
    <div class="section-chart">
      <echart-line
        v-if="currentCategoryVal.chartType=='line'&&!isLoading"
        :category="chartData.category"
        :data="chartData.data"
        unit="kW"
        :unitX="chartData.unitX"
      ></echart-line>
      <echart-bar
        v-if="currentCategoryVal.chartType=='bar'&&!isLoading"
        :category="chartData.category"
        :data="chartData.data"
        unit="kWh"
        :unitX="chartData.unitX"
      ></echart-bar>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import echartLine from "@/components/echarts/line";
import echartBar from "@/components/echarts/bar";
export default {
  components: {
    echartLine,
    echartBar
  },
  data() {
    let nowYear = this.$filter.formatDate(new Date(), "yyyy");
    // 每月日期列表
    let dayList = [];
    for (let i = 1; i <= 31; i++) {
      dayList.push(this.$filter.formatNum(i, 2, "pad"));
    }
    // 每年月份列表
    let monthList = [];
    for (let i = 1; i <= 12; i++) {
      monthList.push(this.$filter.formatNum(i, 2, "pad"));
    }
    return {
      categories: {
        day: {
          label: this.$t("device.day"),
          datepickerType: "date",
          chartType: "line",
          param: {
            action: "querySPDeviceKeyParameterOneDay",
            parameter: [
              {
                name: this.$t("device.pvPower"),
                value: "PV_OUTPUT_POWER"
              },

              {
                name: this.$t("device.loadPower"),
                value: "LOAD_ACTIVE_POWER"
              },
              {
                name: this.$t("device.batteryPower"),
                value: "BATTERY_ACTIVE_POWER"
              },
              {
                name: this.$t("device.gridPower"),
                value: "GRID_ACTIVE_POWER"
              }
            ], // 图表各模块数据接口
            dateFormat: "yyyy-MM-dd", // 传参日期格式
            fields: ["detail", "ts"] // 响应数据字段
          }
        },
        month: {
          label: this.$t("device.month"),
          datepickerType: "month",
          chartType: "bar",
          param: {
            action: "querySPDeviceKeyParameterMonthPerDay",
            parameter: [
              {
                name: this.$t("device.generated"),
                value: "ENERGY_TODAY"
              },
              {
                name: this.$t("device.bought"),
                value: "ENERGY_TODAY_FROM_GRID",
                devcode: 2363 // 该协议下该参数被排除
              },
              {
                name: this.$t("device.sold"),
                value: "ENERGY_TODAY_TO_GRID",
                devcode: 2363
              },
              {
                name: this.$t("device.charged"),
                value: "BATTERY_ENERGY_TODAY_CHARGE",
                devcode: 2363
              },
              {
                name: this.$t("device.discharged"),
                value: "BATTERY_ENERGY_TODAY_DISCHARGE",
                devcode: 2363
              },
              {
                name: this.$t("device.used"),
                value: "LOAD_ENERGY_TODAY"
              }
            ],
            dateFormat: "yyyy-MM",
            fields: ["option", "gts"]
          },
          chartFormat: "dd",
          chartCategory: dayList // 图表x轴
        },
        year: {
          label: this.$t("device.year"),
          datepickerType: "year",
          chartType: "bar",
          param: {
            action: "querySPDeviceKeyParameterYearPerMonth",
            parameter: [
              {
                name: this.$t("device.generated"),
                value: "ENERGY_TOTAL"
              },
              {
                name: this.$t("device.bought"),
                value: "ENERGY_TOTAL_FROM_GRID",
                devcode: 2363
              },
              {
                name: this.$t("device.sold"),
                value: "ENERGY_TOTAL_TO_GRID",
                devcode: 2363
              },
              {
                name: this.$t("device.charged"),
                value: "BATTERY_ENERGY_TOTAL_CHARGE",
                devcode: 2363
              },
              {
                name: this.$t("device.discharged"),
                value: "BATTERY_ENERGY_TOTAL_DISCHARGE",
                devcode: 2363
              },
              {
                name: this.$t("device.used"),
                value: "LOAD_ENERGY_TOTAL"
              }
            ],
            dateFormat: "yyyy",
            fields: ["option", "gts"]
          },
          chartFormat: "MM",
          chartCategory: monthList
        },
        all: {
          label: this.$t("device.all"),
          chartType: "bar",
          param: {
            action: "querySPDeviceKeyParameterTotalPerYear",
            parameter: [
              {
                name: this.$t("device.generated"),
                value: "ENERGY_TOTAL"
              },
              {
                name: this.$t("device.bought"),
                value: "ENERGY_TOTAL_FROM_GRID",
                devcode: 2363
              },
              {
                name: this.$t("device.sold"),
                value: "ENERGY_TOTAL_TO_GRID",
                devcode: 2363
              },
              {
                name: this.$t("device.charged"),
                value: "BATTERY_ENERGY_TOTAL_CHARGE",
                devcode: 2363
              },
              {
                name: this.$t("device.discharged"),
                value: "BATTERY_ENERGY_TOTAL_DISCHARGE",
                devcode: 2363
              },
              {
                name: this.$t("device.used"),
                value: "LOAD_ENERGY_TOTAL"
              }
            ],
            dateFormat: null,
            fields: ["option", "gts"]
          },
          chartFormat: "yyyy",
          chartCategory: [
            nowYear - 4,
            nowYear - 3,
            nowYear - 2,
            nowYear - 1,
            nowYear - 0
          ]
        }
      },
      chartData: {
        category: [], // 数据模块
        data: [],
        unitX:""
      }, // 图表数据
      currentCategoryKey: "day", // 当前选择时间类别
      chartDate: new Date(), // 当前所选时间
      isLoading: false // 正在加载数据
    };
  },
  computed: {
    currentCategoryVal() {
      return this.categories[this.currentCategoryKey];
    },
    ...mapGetters({
      deviceInfo: "getDeviceInfo"
    })
  },
  watch: {
    deviceInfo: {
      handler() {
        this.queryData();
      },
      deep: true
    },
    currentCategoryKey() {
      this.chartDate = new Date();
      this.queryData();
    },
    chartDate() {
      this.queryData();
    }
  },
  created() {
    this.queryData();
  },
  methods: {
    // 查询图表数据
    async queryData() {
      let date = this.currentCategoryVal.param.dateFormat
          ? this.$filter.formatDate(
              this.chartDate,
              this.currentCategoryVal.param.dateFormat
            )
          : null,
        chartData = {
          category: [],
          data: [],
          unitX: ""
        },
        loadedParam = 0;
        //给X轴新加时间单位
        if(this.currentCategoryVal.datepickerType == "date"){
          chartData.unitX = "H"
        } else if(this.currentCategoryVal.datepickerType == "month"){
          chartData.unitX = "D"
        } else if(this.currentCategoryVal.datepickerType == "year"){
          chartData.unitX = "M"
        } else{
          chartData.unitX = "Y"
        }
      this.isLoading = true;
      let parameters = this.currentCategoryVal.param.parameter.filter(item => {
        if (!item.devcode) return true;
        return this.$store.state.device.devcode != item.devcode;
      });
      await parameters.forEach((parameter, index, arr) => {
        let requestParam = {
          pn: this.deviceInfo.pn,
          sn: this.deviceInfo.sn,
          devcode: this.deviceInfo.devcode,
          devaddr: this.deviceInfo.devaddr,
          i18n: this.$lang.currentLang,
          parameter: parameter.value,
          date
        };

        this.$request
          .get(this.currentCategoryVal.param.action, requestParam)
          .then(res => {
            let category = [],
              fields = this.currentCategoryVal.param.fields;
            chartData.data[index] = {
              name: parameter.name,
              value: []
            };
            if (res.err === 0) {
              res.dat[fields[0]] &&
                res.dat[fields[0]].forEach(item => {
                  if (this.currentCategoryVal.chartType === "bar") {
                    // 总数据
                    category = this.currentCategoryVal.chartCategory;
                    category.forEach((citem, cindex) => {
                      if (
                        citem ==
                        this.$filter.formatDate(
                          item[fields[1]],
                          this.currentCategoryVal.chartFormat
                        )
                      ) {
                        chartData.data[index].value[cindex] = (
                          item.val - 0
                        ).toFixed(2);
                      }
                    });
                  } else if (this.currentCategoryVal.chartType === "line") {
                    // 日数据
                    category.push(item[fields[1]]);
                    chartData.data[index].value.push((item.val - 0).toFixed(2));
                  }
                });
               // 所有模块数据加载完后赋给图表显示
            if (++loadedParam === arr.length) {
              chartData.category = category;
              this.chartData = chartData;
              // console.log(this.chartData, "图标数据");
              var bbb = this.chartData;
              var numArr =[]
              for (var a = 0; a < bbb.data.length; a++) {
                for (var i = 0; i < bbb.data[a].value.length; i++) {
                  // 为负值是保留直接push进数组,不然Math.ceil会将负零点几的数值直接处理为0
                  if(bbb.data[a].value[i]<0){
                    numArr.push(a)
                    break;
                  }else{
                  // console.log("Math.ceil(bbb.data[a].value[i])",Math.ceil(bbb.data[a].value[i]))
                  if (Math.ceil(bbb.data[a].value[i]) == "0") {
                    // lll = true;
                  }else if(bbb.data[a].value[i] == undefined){
                    // console.log("undefined")
                  } else {
                    // lll = false;
                    numArr.push(a)
                    break;
                  }
                  }
                }
              }
                this.isLoading = false;
                var newChartData = []
                newChartData.data =[]
                numArr.forEach(element => {
                newChartData.data.push(this.chartData.data[element])
              });
              this.chartData.data = newChartData.data
            }
            } else {
              // 日数据为空时填充0
              if (this.currentCategoryVal.chartType === "line") {
                category.push(
                  this.$filter.formatDate(this.chartDate, "yyyy-MM-dd") +
                    " 00:00:00",
                  this.$filter.formatDate(this.chartDate, "yyyy-MM-dd") +
                    " 23:59:59"
                );
                chartData.data[index].value.push("0.00", "0.00");
                chartData.data[index].name = "";
                chartData.category = category
                this.chartData = chartData
                this.isLoading = false
              }
            }
          });
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");
.section {
  display: flex;
  flex-direction: column;
  border: none;
  box-shadow: none;
  padding: 0px;
  margin-top: 20px;
  .section-header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .tool {
      display: flex;
      align-items: center;
      .datepicker {
        margin-right: 15px;
      }
      .category {
        padding: 5.5px 25px;
        border-radius: 20px;
        margin-left: 5px;
        .sc(14px, #333);
        cursor: pointer;
        border: 1px solid transparent;
        &:hover {
          border-color: @themeColor;
          color: @themeColor;
        }
        &.selected {
          background: @themeColor;
          color: #fff;
        }
      }
    }
  }
  .section-chart {
    flex: 1;
  }
}
</style>